import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { usePermissions } from 'src/hooks/auth/usePermissions'
import { useAuth } from 'src/contexts/auth'
import ROUTES from 'src/constants/routes'
import { UserType } from 'src/routes/routes.config'
import { Loading } from 'src/components/Loading'
export interface ProtectedRouteProps {
  roles?: UserType[]
  children?: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles, children }) => {
  const { loading, authenticated, tokenExpired } = useAuth()
  const { hasRole } = usePermissions()

  if (loading) {
    return <Loading />
  }

  if (!authenticated || !tokenExpired) {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />
  }

  if (roles && !hasRole(roles)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  if (children) {
    return <>{children}</>
  }

  return <Outlet />
}
